function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "night-cloudy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "24.4644699%",
  y1: "73.2162538%",
  x2: "63.7305027%",
  y2: "39.8283719%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#CFCFCF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "72.6181818%",
  y1: "64.7966936%",
  x2: "8.47272727%",
  y2: "22.8606986%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "2%"
}), React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "night-cloudy",
  transform: "translate(0.000000, 1.000000)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M108.229521,46.3654306 C97.9131645,45.5172725 88.53389,39.953264 82.7333114,31.2404733 C76.9327327,22.5276827 75.3385213,11.6089071 78.3996768,1.55935133 C78.5571225,0.982114592 78.3612471,0.365028759 77.9015865,-0.00983210359 C77.4419259,-0.384692967 76.8067983,-0.445303969 76.2865247,-0.163959415 C63.7568896,7.05636723 57.0404557,21.4989541 59.5044492,35.923135 C61.9684428,50.3473159 73.0816215,61.6432072 87.2724893,64.1477114 C101.463357,66.6522157 115.672333,59.8253564 122.77587,47.0897206 C123.103347,46.5571906 123.069406,45.8735982 122.690848,45.3772848 C122.31229,44.8809713 121.669424,44.6772291 121.080434,44.8668995 C116.929684,46.1932751 112.56795,46.7018923 108.229521,46.3654306 L108.229521,46.3654306 Z",
  id: "Path",
  fill: "#EFCC00"
}), React.createElement("path", {
  d: "M43.4579471,34.6604543 C59.5184737,34.6554002 74.2630645,43.5723729 81.7653227,57.8273131 C94.1600764,50.5530449 109.76858,51.8654681 120.785087,61.1082455 C131.801595,70.3510229 135.858353,85.5376246 130.926594,99.0732964 C125.994835,112.608968 113.134532,121.584518 98.7770661,121.511311 L43.3341353,121.660454 C19.4013532,121.660454 0,102.184841 0,78.1604543 C0,54.1360694 19.4013532,34.6604543 43.3341353,34.6604543 L43.4579471,34.6604543 Z",
  id: "Path",
  fill: "url(#linearGradient-1)"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  transform: "translate(99.076373, 87.195235) rotate(-74.390000) translate(-99.076373, -87.195235) ",
  cx: 99.0763727,
  cy: 87.1952351,
  rx: 34.1530826,
  ry: 34.0241017
})));

var SvgNightCloudy = function SvgNightCloudy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "134px",
    height: "123px",
    viewBox: "0 0 134 123",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNightCloudy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/night-cloudy.2d624349.svg";
export { ForwardRef as ReactComponent };